import { FC } from "react";
import AppLayout from "../../components/layout/app-layout/app-layout";
import { useTranslation } from "react-i18next";
import { ReactComponent as EyeIcon } from '../../assets/svg/openedEyeIcon.svg';
import { PagePublishedBidRequestsList } from "./page-published-bid-requests-list/page-published-bid-requests-list";

const PagePublicBidRequestList: FC = () => {
  const [t] = useTranslation('requests');

  return (
    <AppLayout title={<div style={{ display: 'flex', gap: '8px', alignItems: 'center', }}><div style={{ borderRadius: '6px', backgroundColor: 'var(--gray-700)', width: '40px', height: '40px', position: 'relative', }}><EyeIcon style={{ fill: 'white', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} /></div><span>{t('published.pageTitle', 'Publicerade förfrågningar')}</span></div>}>
      <PagePublishedBidRequestsList />
    </AppLayout>
  );
}

export default PagePublicBidRequestList;
